"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefreshCustomer = useRefreshCustomer;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var baskets_1 = require("../api/baskets");
var customer_analytics_1 = require("../api/customer_analytics");
var customers_1 = require("../api/customers");
var letsachieve_1 = require("../api/letsachieve");
var loyalty_1 = require("../api/loyalty");
var orders_1 = require("../api/orders");
var payments_1 = require("../api/payments");
var subscriptions_1 = require("../api/subscriptions");
var REFRESH_COOLDOWN_MS = 3000;
function useRefreshCustomer(customerId) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)(false), isRefreshing = _a[0], setIsRefreshing = _a[1];
    (0, react_1.useEffect)(function () {
        if (!isRefreshing)
            return;
        var timer = setTimeout(function () { return setIsRefreshing(false); }, REFRESH_COOLDOWN_MS);
        return function () { return clearTimeout(timer); };
    }, [isRefreshing]);
    // invalidation refetches whatever the page has mounted and marks the rest stale for when its tab opens
    var refresh = (0, react_1.useCallback)(function () {
        if (!customerId)
            return;
        dispatch(letsachieve_1.letsachieveApi.util.invalidateTags([
            "Transaction",
            "ItemTransaction",
            { type: "ItemInventory", id: customerId },
            { type: "ChallengeInventory", id: customerId },
            { type: "PlayerProfile", id: customerId },
            { type: "AuditLog", id: customerId },
        ]));
        dispatch(customers_1.customersApi.util.invalidateTags([{ type: "Customer", id: customerId }, { type: "Address", id: customerId }]));
        dispatch(customer_analytics_1.customerAnalyticsApi.util.invalidateTags([{ type: "CustomerAnalytics", id: customerId }]));
        dispatch(loyalty_1.loyaltyApi.util.invalidateTags([{ type: "Loyalty", id: customerId }]));
        dispatch(payments_1.paymentsApi.util.invalidateTags([{ type: "Wallet", id: customerId }, { type: "Card", id: customerId }]));
        dispatch(orders_1.ordersApi.util.invalidateTags([{ type: "Order", id: customerId }]));
        dispatch(baskets_1.basketsApi.util.invalidateTags([{ type: "Basket", id: customerId }]));
        dispatch(subscriptions_1.subscriptionsApi.util.invalidateTags([{ type: "Subscription", id: customerId }]));
        setIsRefreshing(true);
    }, [customerId, dispatch]);
    return { refresh: refresh, isRefreshing: isRefreshing };
}
